import { render, staticRenderFns } from "./MailchimpModal.vue?vue&type=template&id=c932c64a&"
import script from "./MailchimpModal.vue?vue&type=script&lang=js&"
export * from "./MailchimpModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports